import styled from 'styled-components'

export const ExpWrapper = styled.div ` 
    width: 100%
    

   `